import axios from "axios";

export const ACTION_GET = (url, config) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, config)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        // 401エラーの詳細ログ出力
        if (err?.response?.status === 401) {
          console.error('🚨 401 Unauthorized Error Details:');
          console.error('  URL:', url);
          console.error('  Method: GET');
          console.error('  Status:', err.response.status, err.response.statusText);
          console.error('  Error Message:', err.response?.data?.message || err.message);
          console.error('  Error Body:', err.response?.data);
          console.error('  Request Headers:', config?.headers || 'None');

          // トークン情報のデバッグ
          const token = config?.headers?.Authorization?.replace('Bearer ', '');
          if (token) {
            try {
              const payload = JSON.parse(atob(token.split('.')[1]));
              const currentTime = Math.floor(Date.now() / 1000);
              console.error('  Token Payload:', {
                sub: payload.sub,
                email: payload.email,
                iat: payload.iat,
                exp: payload.exp,
                isExpired: payload.exp < currentTime,
                expiresIn: payload.exp - currentTime
              });
            } catch (e) {
              console.error('  Token decode failed:', e.message);
            }
          }
        }

        reject({ ...err?.response?.data, status: err?.response?.status });
      });
  });
};

export const ACTION_POST = (url, data, config) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, config)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        // 401エラーの詳細ログ出力
        if (err?.response?.status === 401) {
          console.error('🚨 401 Unauthorized Error Details:');
          console.error('  URL:', url);
          console.error('  Method: POST');
          console.error('  Status:', err.response.status, err.response.statusText);
          console.error('  Error Message:', err.response?.data?.message || err.message);
          console.error('  Error Body:', err.response?.data);
          console.error('  Request Headers:', config?.headers || 'None');

          // トークン情報のデバッグ
          const token = config?.headers?.Authorization?.replace('Bearer ', '');
          if (token) {
            try {
              const payload = JSON.parse(atob(token.split('.')[1]));
              const currentTime = Math.floor(Date.now() / 1000);
              console.error('  Token Payload:', {
                sub: payload.sub,
                email: payload.email,
                iat: payload.iat,
                exp: payload.exp,
                isExpired: payload.exp < currentTime,
                expiresIn: payload.exp - currentTime
              });
            } catch (e) {
              console.error('  Token decode failed:', e.message);
            }
          }
        }

        reject({ ...err })
      });
  });
};

export const ACTION_PUT = (url, data, config) => {
  return new Promise((resolve, reject) => {
    axios
      .put(url, data, config)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        // 401エラーの詳細ログ出力
        if (err?.response?.status === 401) {
          console.error('🚨 401 Unauthorized Error Details:');
          console.error('  URL:', url);
          console.error('  Method: PUT');
          console.error('  Status:', err.response.status, err.response.statusText);
          console.error('  Error Message:', err.response?.data?.message || err.message);
          console.error('  Error Body:', err.response?.data);
          console.error('  Request Headers:', config?.headers || 'None');

          // トークン情報のデバッグ
          const token = config?.headers?.Authorization?.replace('Bearer ', '');
          if (token) {
            try {
              const payload = JSON.parse(atob(token.split('.')[1]));
              const currentTime = Math.floor(Date.now() / 1000);
              console.error('  Token Payload:', {
                sub: payload.sub,
                email: payload.email,
                iat: payload.iat,
                exp: payload.exp,
                isExpired: payload.exp < currentTime,
                expiresIn: payload.exp - currentTime
              });
            } catch (e) {
              console.error('  Token decode failed:', e.message);
            }
          }
        }

        reject({ ...err })
      });
  });
};
